// T026 — Audit-log filter chip on the transactions table (US4).
import { SelectButton } from "primereact/selectbutton";

export type AuditFilterValue = "all" | "admin_only";

interface AdminAuditFilterProps {
  value: AuditFilterValue;
  onChange: (next: AuditFilterValue) => void;
}

const options: { label: string; value: AuditFilterValue }[] = [
  { label: "All transactions", value: "all" },
  { label: "Admin actions only", value: "admin_only" },
];

const AdminAuditFilter = ({ value, onChange }: AdminAuditFilterProps) => {
  return (
    <SelectButton
      value={value}
      options={options}
      onChange={(event) => {
        if (event.value) onChange(event.value as AuditFilterValue);
      }}
      allowEmpty={false}
      className="segmented-select"
      pt={{ button: { className: "text-sm" } }}
    />
  );
};

export default AdminAuditFilter;
